/**
 * PatrioticFireworks
 * -------------------------------------------------------------------------
 * Fires low-intensity red-white-blue confetti bursts every ~7 seconds while
 * mounted. Meant to sit inside a parent that only renders us when the
 * Patriotic theme is active — see the `patrioticActive` gate on HomePage.
 *
 * Kept intentionally subtle vs. the 25-email milestone celebration in
 * CrewTallyPage — this is ambient decor, not a reward moment. Each burst is
 * a single small pop from two off-screen origins, alternating sides so the
 * effect doesn't crowd the center of the screen.
 *
 * Respects `prefers-reduced-motion`: no bursts fire at all in that mode.
 * The parent's static CSS decor (stars, stripe) stays visible either way.
 */
import { useEffect } from "react";
import confetti from "canvas-confetti";

const PATRIOTIC_COLORS = ["#DC2626", "#FFFFFF", "#2563EB"]; // red, white, blue

export default function PatrioticFireworks() {
  useEffect(() => {
    // Bail entirely when the user prefers reduced motion.
    try {
      const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
      if (mq.matches) return;
    } catch { /* SSR / private mode */ }

    let side = 0;
    const burst = () => {
      const x = side === 0 ? 0.15 : 0.85;
      confetti({
        particleCount: 45,
        spread: 70,
        startVelocity: 32,
        ticks: 55,
        origin: { x, y: 0.15 },
        colors: PATRIOTIC_COLORS,
        zIndex: 1000,
        disableForReducedMotion: true,
      });
      side = 1 - side;
    };

    // Fire an initial burst ~1s after mount so it registers, then repeat.
    const first = setTimeout(burst, 1000);
    const id = setInterval(burst, 7500);
    return () => {
      clearTimeout(first);
      clearInterval(id);
    };
  }, []);

  return null;
}
